import s from "swr";
const n = "/api/", o = "urgentcare/waits", a = ({
  revalidateOnFocus: e = !1
}) => ({
  ...s(`${n}${o}`, {
    revalidateOnFocus: e
  })
});
export {
  a as u
};
